import React from "react";
import {
 Box,
 Heading,
 Table,
 Thead,
 Tbody,
 Tr,
 Th,
 Td,
 TableContainer,
 Text,
} from "@chakra-ui/react";

// Helper to safely format fees
const formatFees = (fees) => {
 if (!fees) return "N/A";
 if (typeof fees === "string") return fees;
 if (typeof fees === "number") {
  return new Intl.NumberFormat("en-IN", {
   style: "currency",
   currency: "INR",
   maximumFractionDigits: 0,
  }).format(fees);
 }
 return "N/A";
};

const DeemedCoursesSection = ({ courses }) => {
 if (!courses || !Array.isArray(courses) || courses.length === 0) return null;

 return (
  <Box mb={8}>
   <Heading as="h2" size="md" mb={4}>
    Courses Offered
   </Heading>

   <TableContainer
    border="1px"
    borderColor="gray.200"
    borderRadius="md"
    boxShadow="sm"
   >
    <Table variant="simple" size={{ base: "sm", md: "md" }}>
     <Thead bg="gray.50">
      <Tr>
       <Th>Name</Th>
       <Th>Duration</Th>
       <Th>Eligibility</Th>
       <Th isNumeric>Fees (INR)</Th>
       <Th isNumeric>NRI Fees</Th>
       <Th isNumeric>Hostel Fees</Th>
      </Tr>
     </Thead>
     <Tbody>
      {courses.map((course, index) => (
       <React.Fragment key={index}>
        <Tr>
         <Td fontWeight="medium">{course.name || "N/A"}</Td>
         <Td>{course.duration || "N/A"}</Td>
         <Td>{course.eligibility || "N/A"}</Td>
         <Td isNumeric>
          <Text color="gray.700" fontWeight="semibold">
           {course.fees?.inr ? course.fees.inr : formatFees(course.fees)}
          </Text>
         </Td>
         <Td isNumeric>
          <Text color="gray.700" fontWeight="semibold">
           {course.fees?.nri ? course.fees.nri : "N/A"}
          </Text>
         </Td>
         <Td isNumeric>
          <Text color="gray.700" fontWeight="semibold">
           {course.fees?.hostel ? course.fees.hostel : "N/A"}
          </Text>
         </Td>
        </Tr>

        {/* PG Specializations */}
        {course.specializations && course.specializations.length > 0 && (
         <Tr>
          <Td colSpan={3}>
           <Box mt={3}>
            <Text fontWeight="semibold" mb={2}>
             Specializations (Seats & Fees):
            </Text>
            <Table size="sm" variant="striped">
             <Thead>
              <Tr>
               <Th>Specialization</Th>
               <Th isNumeric>All India Seats</Th>
               <Th isNumeric>NRI Seats</Th>
               <Th isNumeric>All India Fee</Th>
               <Th isNumeric>NRI Fee</Th>
              </Tr>
             </Thead>
             <Tbody>
              {course.specializations.map((spec, idx) => (
               <Tr key={idx}>
                <Td>{spec.name || "N/A"}</Td>
                <Td isNumeric>{spec.allIndiaSeats || "N/A"}</Td>
                <Td isNumeric>{spec.nriSeats || "N/A"}</Td>
                <Td isNumeric>
                 {spec.allIndiaFee ? formatFees(spec.allIndiaFee) : "N/A"}
                </Td>
                <Td isNumeric>
                 {spec.nriFee ? formatFees(spec.nriFee) : "N/A"}
                </Td>
               </Tr>
              ))}
             </Tbody>
            </Table>

            {(course.stipend || course.hostelFees) && (
             <Box mt={3}>
              {course.stipend && (
               <Text>
                <strong>Stipend:</strong> {course.stipend}
               </Text>
              )}
              {course.hostelFees && (
               <Text>
                <strong>Hostel Fees:</strong> {formatFees(course.hostelFees)}
               </Text>
              )}
             </Box>
            )}
           </Box>
          </Td>
         </Tr>
        )}
       </React.Fragment>
      ))}
     </Tbody>
    </Table>
   </TableContainer>
  </Box>
 );
};

export default DeemedCoursesSection;

// import React from "react";
// import {
//  Box,
//  Heading,
//  Table,
//  Thead,
//  Tbody,
//  Tr,
//  Th,
//  Td,
//  TableContainer,
//  Text,
// } from "@chakra-ui/react";

// // Format function
// const formatFees = (fees) => {
//  if (!fees) return "N/A";
//  if (typeof fees === "string") return fees;
//  return new Intl.NumberFormat("en-IN", {
//   style: "currency",
//   currency: "INR",
//   maximumFractionDigits: 0,
//  }).format(fees);
// };

// const DeemedCoursesSection = ({ courses }) => {
//  if (!courses || courses.length === 0) return null;

//  return (
//   <Box mb={8}>
//    <Heading as="h2" size="md" mb={4}>
//     Courses Offered
//    </Heading>

//    <TableContainer
//     border="1px"
//     borderColor="gray.200"
//     borderRadius="md"
//     boxShadow="sm"
//    >
//     <Table variant="simple" size={{ base: "sm", md: "md" }}>
//      <Thead bg="gray.50">
//       <Tr>
//        <Th>Name</Th>
//        <Th>Duration</Th>
//        <Th>Eligibility</Th>
//        <Th isNumeric>Fees</Th>
//       </Tr>
//      </Thead>
//      <Tbody>
//       {courses.map((course, index) => (
//        <React.Fragment key={index}>
//         <Tr>
//          <Td fontWeight="medium">{course.name}</Td>
//          <Td>{course.duration}</Td>
//          <Td>{course.eligibility}</Td>
//          <Td isNumeric>
//           <Text color="gray.700" fontWeight="semibold">
//            {formatFees(course.fees)}
//           </Text>
//          </Td>
//         </Tr>

//         {/* PG Specializations with fees/seats */}
//         {course.specializations && course.specializations.length > 0 && (
//          <Tr>
//           <Td colSpan={4}>
//            <Box mt={3}>
//             <Text fontWeight="semibold" mb={2}>
//              Specializations (Seats & Fees):
//             </Text>
//             <Table size="sm" variant="striped">
//              <Thead>
//               <Tr>
//                <Th>Specialization</Th>
//                <Th isNumeric>All India Seats</Th>
//                <Th isNumeric>NRI Seats</Th>
//                <Th isNumeric>All India Fee</Th>
//                <Th isNumeric>NRI Fee</Th>
//               </Tr>
//              </Thead>
//              <Tbody>
//               {course.specializations.map((spec, idx) => (
//                <Tr key={idx}>
//                 <Td>{spec.name}</Td>
//                 <Td isNumeric>{spec.allIndiaSeats || "N/A"}</Td>
//                 <Td isNumeric>{spec.nriSeats || "N/A"}</Td>
//                 <Td isNumeric>
//                  {spec.allIndiaFee ? formatFees(spec.allIndiaFee) : "N/A"}
//                 </Td>
//                 <Td isNumeric>
//                  {spec.nriFee ? formatFees(spec.nriFee) : "N/A"}
//                 </Td>
//                </Tr>
//               ))}
//              </Tbody>
//             </Table>

//             {/* Stipend and hostel fees display */}
//             {(course.stipend || course.hostelFees) && (
//              <Box mt={3}>
//               {course.stipend && (
//                <Text>
//                 <strong>Stipend:</strong> {course.stipend}
//                </Text>
//               )}
//               {course.hostelFees && (
//                <Text>
//                 <strong>Hostel Fees:</strong> {formatFees(course.hostelFees)}
//                </Text>
//               )}
//              </Box>
//             )}
//            </Box>
//           </Td>
//          </Tr>
//         )}
//        </React.Fragment>
//       ))}
//      </Tbody>
//     </Table>
//    </TableContainer>
//   </Box>
//  );
// };

// export default DeemedCoursesSection;

// // import React from "react";
// // import {
// //  Box,
// //  Heading,
// //  Table,
// //  Thead,
// //  Tbody,
// //  Tr,
// //  Th,
// //  Td,
// //  TableContainer,
// //  Text,
// // } from "@chakra-ui/react";

// // // Function to format fees
// // const formatFees = (fees) => {
// //  if (!fees) return "N/A";
// //  if (typeof fees === "string") return fees;

// //  return new Intl.NumberFormat("en-IN", {
// //   style: "currency",
// //   currency: "INR",
// //   maximumFractionDigits: 0,
// //  }).format(fees);
// // };

// // const DeemedCoursesSection = ({ courses }) => {
// //  if (!courses || courses.length === 0) return null;

// //  return (
// //   <Box mb={8}>
// //    <Heading as="h2" size="md" mb={4}>
// //     Courses Offered
// //    </Heading>

// //    <TableContainer
// //     border="1px"
// //     borderColor="gray.200"
// //     borderRadius="md"
// //     boxShadow="sm"
// //    >
// //     <Table variant="simple" size={{ base: "sm", md: "md" }}>
// //      <Thead bg="gray.50">
// //       <Tr>
// //        <Th>Name</Th>
// //        <Th>Duration</Th>
// //        <Th>Eligibility</Th>
// //        <Th isNumeric>Fees</Th>
// //       </Tr>
// //      </Thead>
// //      <Tbody>
// //       {courses.map((course, index) => (
// //        <React.Fragment key={index}>
// //         <Tr>
// //          <Td fontWeight="medium">{course.name}</Td>
// //          <Td>{course.duration}</Td>
// //          <Td>{course.eligibility}</Td>
// //          <Td isNumeric>
// //           <Text color="gray.700" fontWeight="semibold">
// //            {formatFees(course.fees)}
// //           </Text>
// //          </Td>
// //         </Tr>

// //         {/* If the course has specializations, show them */}
// //         {course.specializations && course.specializations.length > 0 && (
// //          <Tr>
// //           <Td colSpan={4} p={4}>
// //            <Box mt={2}>
// //             <Text fontWeight="semibold" mb={2}>
// //              Specializations (Fee details):
// //             </Text>
// //             <Table size="sm" variant="striped">
// //              <Thead>
// //               <Tr>
// //                <Th>Specialization</Th>
// //                <Th isNumeric>All India Fee</Th>
// //                <Th isNumeric>NRI Fee</Th>
// //               </Tr>
// //              </Thead>
// //              <Tbody>
// //               {course.specializations.map((spec, idx) => (
// //                <Tr key={idx}>
// //                 <Td>{spec.name}</Td>
// //                 <Td isNumeric>{formatFees(spec.allIndiaFee)}</Td>
// //                 <Td isNumeric>
// //                  {spec.nriFee ? formatFees(spec.nriFee) : "N/A"}
// //                 </Td>
// //                </Tr>
// //               ))}
// //              </Tbody>
// //             </Table>

// //             {/* Additional details (stipend and hostel fee) if available */}
// //             <Box mt={3}>
// //              {course.stipend && (
// //               <Text>
// //                <strong>Stipend:</strong> {course.stipend}
// //               </Text>
// //              )}
// //              {course.hostelFees && (
// //               <Text>
// //                <strong>Hostel Fees:</strong> {formatFees(course.hostelFees)}
// //               </Text>
// //              )}
// //             </Box>
// //            </Box>
// //           </Td>
// //          </Tr>
// //         )}
// //        </React.Fragment>
// //       ))}
// //      </Tbody>
// //     </Table>
// //    </TableContainer>
// //   </Box>
// //  );
// // };

// // export default DeemedCoursesSection;

// // // import React from "react";
// // // import {
// // //  Box,
// // //  Heading,
// // //  Table,
// // //  Thead,
// // //  Tbody,
// // //  Tr,
// // //  Th,
// // //  Td,
// // //  TableContainer,
// // //  Text,
// // // } from "@chakra-ui/react";

// // // // Function to format fees
// // // const formatFees = (fees) => {
// // //  if (!fees) return "N/A";

// // //  // If fees is already a string, return it
// // //  if (typeof fees === "string") return fees;

// // //  // Format number to Indian Rupee format
// // //  return new Intl.NumberFormat("en-IN", {
// // //   style: "currency",
// // //   currency: "INR",
// // //   maximumFractionDigits: 0,
// // //  }).format(fees);
// // // };

// // // const DeemedCoursesSection = ({ courses }) => {
// // //  if (!courses || courses.length === 0) {
// // //   return null;
// // //  }

// // //  return (
// // //   <Box mb={8}>
// // //    <Heading as="h2" size="md" mb={4}>
// // //     Courses Offered
// // //    </Heading>

// // //    <TableContainer
// // //     border="1px"
// // //     borderColor="gray.200"
// // //     borderRadius="md"
// // //     boxShadow="sm"
// // //    >
// // //     <Table variant="simple" size={{ base: "sm", md: "md" }}>
// // //      <Thead bg="gray.50">
// // //       <Tr>
// // //        <Th>Name</Th>
// // //        <Th>Duration</Th>
// // //        <Th>Eligibility</Th>
// // //        <Th isNumeric>Fees</Th>
// // //       </Tr>
// // //      </Thead>
// // //      <Tbody>
// // //       {courses.map((course, index) => (
// // //        <Tr key={index}>
// // //         <Td fontWeight="medium">{course.name}</Td>
// // //         <Td>{course.duration}</Td>
// // //         <Td>{course.eligibility}</Td>
// // //         <Td isNumeric>
// // //          <Text color="gray.700" fontWeight="semibold">
// // //           {formatFees(course.fees)}
// // //          </Text>
// // //         </Td>
// // //        </Tr>
// // //       ))}
// // //      </Tbody>
// // //     </Table>
// // //    </TableContainer>
// // //   </Box>
// // //  );
// // // };

// // // export default DeemedCoursesSection;
